"use strict";

exports.__esModule = true;
exports.DataAccessController = void 0;
var _queryString = require("query-string");
var DataAccessController = exports.DataAccessController = function DataAccessController(_ref) {
  var children = _ref.children,
    api = _ref.api;
  var dataAccessors = {
    getUsers: function getUsers() {
      return api.get("/api/v1/auth/admin/users");
    },
    getCalendar: function getCalendar() {
      return api.get("/api/v3/calendar/calendar");
    },
    getCurrentCalendar: function getCurrentCalendar() {
      return api.get("/api/v3/calendar/current");
    },
    getCurrentWorkday: function getCurrentWorkday() {
      return api.get("/api/v3/calendar/workday/current");
    },
    getCurrentShift: function getCurrentShift() {
      return api.get("/api/v3/calendar/shift/current");
    },
    getTimezone: function getTimezone() {
      return api.get("/api/v3/calendar/timezone");
    },
    getDevices: function getDevices() {
      return api.get("/api/v1/plant/device?withDataItems=true");
    },
    getDeviceTags: function getDeviceTags() {
      return api.get("/api/v1/plant/device/tags");
    },
    getTimelineSchema: function getTimelineSchema() {
      return api.get("/api/v3/timeseries/timeline/schema");
    },
    getReportTags: function getReportTags() {
      return api.get("/api/v3/ui-config/reports/tags");
    },
    getReportConfig: function getReportConfig(id) {
      return api.get("/api/v3/ui-config/reports/" + id);
    },
    getRawConnectData: function getRawConnectData(query) {
      return api.get("/api/v1/connectdata/?" + (0, _queryString.stringify)(query));
    },
    getRawS3ConnectData: function getRawS3ConnectData(query) {
      return api.get("/api/v1/connectdata/connectdata/json?" + (0, _queryString.stringify)(query));
    },
    getAggregatedS3ConnectData: function getAggregatedS3ConnectData(query) {
      return api.get("/api/v1/connectdata/aggregate/json?" + (0, _queryString.stringify)(query));
    },
    getRawConnectMTCData: function getRawConnectMTCData(query) {
      return api.get("/api/v1/connectdata/mtcdata?" + (0, _queryString.stringify)(query));
    },
    getTimeline: function getTimeline(query) {
      return api.get("/api/v3/timeseries/timeline?" + (0, _queryString.stringify)(query));
    },
    getAdvancedTimeline: function getAdvancedTimeline(body) {
      return api.post("/api/v3/timeseries/timeline/raw", body);
    },
    getAlerts: function getAlerts(query) {
      return api.get("/api/v3/alerts/alert?" + (0, _queryString.stringify)(query));
    },
    getComments: function getComments(body) {
      return api.post("/api/v1/comments/comment", body);
    },
    getDecisionTrees: function getDecisionTrees() {
      return api.get("/api/v3/decision-tree/nodes");
    },
    getDecisionTreeNode: function getDecisionTreeNode(id, query) {
      return api.get("/api/v3/decision-tree/node/" + id + "?" + (0, _queryString.stringify)(query));
    },
    getPlantStateActivities: function getPlantStateActivities() {
      return api.get("/api/v1/plant/plant-state-activities");
    },
    getPlantStateActivitiesDevices: function getPlantStateActivitiesDevices() {
      return api.get("/api/v1/plant/plant-state-activities-devices");
    },
    getDataOnDemandJobList: function getDataOnDemandJobList() {
      return api.get("/api/v3/data-on-demand/jobs/");
    },
    getDataOnDemandJob: function getDataOnDemandJob(id) {
      return api.get("/api/v3/data-on-demand/job/" + id);
    },
    createDataOnDemandJob: function createDataOnDemandJob(body) {
      return api.post("/api/v3/data-on-demand/job", body);
    },
    // TODO svc-connectdata does not support this URL
    getDownloadDataOnDemandUrl: function getDownloadDataOnDemandUrl(query) {
      return "/api/v1/connectdata/download?" + (0, _queryString.stringify)(query);
    },
    createTicket: function createTicket(body) {
      return api.post("/api/v1/ticketing/ticket", body);
    },
    getWatcherRules: function getWatcherRules(query) {
      return api.post("/api/v1/ticketing/apply-watcher-rules", query);
    },
    getTickets: function getTickets(query) {
      return api.get("/api/v1/ticketing/ticket?" + (0, _queryString.stringify)(query));
    },
    getTicket: function getTicket(id) {
      return api.get("/api/v1/ticketing/ticket/" + id);
    },
    getTicketComments: function getTicketComments(id) {
      return api.get("/api/v1/ticketing/ticket/" + id + "/comment");
    },
    updateTicket: function updateTicket(id, body) {
      return api.put("/api/v1/ticketing/ticket/" + id, body);
    },
    createTicketComment: function createTicketComment(ticketId, body) {
      return api.post("api/v1/ticketing/ticket/" + ticketId + "/comment", body);
    },
    updateTicketComment: function updateTicketComment(ticketId, commentId, body) {
      return api.put("api/v1/ticketing/ticket/" + ticketId + "/comment/" + commentId, body);
    },
    deleteTicketComment: function deleteTicketComment(ticketId, commentId) {
      return api["delete"]("/api/v1/ticketing/ticket/" + ticketId + "/comment/" + commentId);
    },
    createComment: function createComment(body) {
      return api.post("/api/v1/comments/comment/create", body);
    },
    getTicketTypes: function getTicketTypes() {
      return api.get("/api/v1/ticketing/ticket-type");
    },
    filterTicketTypes: function filterTicketTypes(body) {
      return api.post("/api/v1/ticketing/filter-ticket-types", body);
    },
    getMetrics: function getMetrics(body) {
      return api.post("/api/v3/timeseries-metrics/", body);
    },
    getFlattenedMetricsData: function getFlattenedMetricsData(body) {
      return api.post("/api/v3/timeseries-metrics/flattened", body);
    },
    getTargets: function getTargets(body) {
      return api.post("/api/v3/target/search", body);
    },
    updateComment: function updateComment(body) {
      return api.post("/api/v1/comments/comment/update", body);
    },
    deleteComment: function deleteComment(body) {
      return api.post("/api/v1/comments/comment/delete", body);
    },
    getAuditLogs: function getAuditLogs(query) {
      return api.get("api/v1/audit-log?" + (0, _queryString.stringify)(query));
    },
    getNotifications: function getNotifications() {
      return api.get("/api/v1/notifications/");
    },
    createNotification: function createNotification(newNotification) {
      return api.post("/api/v1/notifications/", newNotification);
    },
    updateNotification: function updateNotification(id, updatedNotification) {
      return api.put("/api/v1/notifications/" + id, updatedNotification);
    },
    getNotificationsForUser: function getNotificationsForUser(userID) {
      return api.get("/api/v1/notifications/user/" + userID);
    },
    getNotificationsEventSource: function getNotificationsEventSource(userID) {
      return api.getEventSource("/api/v1/notifications/stream/" + userID);
    },
    readNotification: function readNotification(id, body) {
      return api.put("/api/v1/notifications/" + id + "/read", body);
    },
    markAllNotificationsAsRead: function markAllNotificationsAsRead(body) {
      return api.put("/api/v1/notifications/mark-all-as-read", body);
    },
    getPlants: function getPlants() {
      return api.get("/api/v1/auth/provision/plants");
    },
    getPlantDetailsByName: function getPlantDetailsByName(plantName) {
      return api.get("/api/v3/licensing/plant/" + plantName);
    },
    getHistoricalPartCountData: function getHistoricalPartCountData(query) {
      return api.get("/api/v1/part-count/part-counts?" + (0, _queryString.stringify)(query));
    },
    getHistoricalPartCountShiftData: function getHistoricalPartCountShiftData(query) {
      return api.get("/api/v1/part-count/part-counts/shift?" + (0, _queryString.stringify)(query));
    },
    sendAIChatMessage: function sendAIChatMessage(body) {
      return api.post("/api/v1/chat", body);
    }
  };
  return children(dataAccessors);
};